// src/pages/DivisionsDirectory.js

import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import UnifiedDirectory from "../components/UnifiedDirectory";
import {
  getDivisions,
  createDivision,
  updateDivision,
  deleteDivision,
  getTimezones,
} from "../api/enterprise";
import { notifyError } from "../utils/toasts";

function DivisionsDirectory() {
  const { t } = useTranslation();
  const { enterpriseId } = useParams();
  const [divisions, setDivisions] = useState([]);
  const [timezones, setTimezones] = useState({});

  const fetchDivisions = useCallback(async () => {
    if (enterpriseId) {
      try {
        const result = await getDivisions(enterpriseId);
        const transformed = result.map((division) => ({
          ...division,
          // Склеиваем timezone и offset в одну строку для удобства
          time: `${division.timezone} ${division.offset}`, 
        }));
        setDivisions(transformed);
      } catch (error) {
        notifyError(error?.response?.data?.message || error.message);
      }
    }
  }, [enterpriseId]);

  const fetchTimezones = useCallback(async () => {
    try {
      const tzData = await getTimezones();
      setTimezones(tzData);
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  }, []);

  useEffect(() => {
    fetchDivisions();
    fetchTimezones();
  }, [fetchDivisions, fetchTimezones]);

  const handleAddDivision = async (name, timezone) => {
    try {
      await createDivision(enterpriseId, name, timezone);
      await fetchDivisions();
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  };

  const handleEditDivision = async (item, name, timezone) => {
    try {
      await updateDivision(item.division_id, name, timezone);
      await fetchDivisions();
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  };

  const handleDeleteDivision = async (item) => {
    try {
      await deleteDivision(item.division_id);
      await fetchDivisions();
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  };

  return (
    <UnifiedDirectory
      title={t("enterprise_divisions")}
      data={divisions}
      onAdd={handleAddDivision}
      onEdit={handleEditDivision}
      onDelete={handleDeleteDivision}
      fields={["name", "timezone"]} 
      displayFields={["name", "time", "upserted_at"]} 
      timezones={timezones}
    />
  );
}

export default DivisionsDirectory;
